import { render, staticRenderFns } from "./right_6.vue?vue&type=template&id=63f9ce34&scoped=true&"
import script from "./right_6.vue?vue&type=script&lang=js&"
export * from "./right_6.vue?vue&type=script&lang=js&"
import style0 from "./right_6.vue?vue&type=style&index=0&id=63f9ce34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f9ce34",
  null
  
)

export default component.exports